export default "__VITE_ASSET__FBGvEaTE__"